import { useEffect } from 'react';

import { useAppDispatch } from '@/store/hooks';
import { setJourney } from '@/services/journeys/journeysSlice';
import JourneyContainer from '@/services/journeys/JourneyContainer';

function DirectJourneyContainer({ children }: React.PropsWithChildren) {
  const dispatch = useAppDispatch();

  useEffect(() => {
    // Set the journey to 'direct' immediately when this container mounts
    dispatch(setJourney('direct'));
  }, [dispatch]);

  return (
    <JourneyContainer journey="direct">
      {children}
    </JourneyContainer>
  );
}

export default DirectJourneyContainer;
